// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__xDJsx","logoImage":"Logo_logoImage__Q-W7w"};